import { SET_LICENSES, RESET, SET_LICENSE  } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    licenses : {},
    licensesSorted : [],
    license : {}
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('Licenses - Reducer')

  switch (action.type) {
    case SET_LICENSE:

      state.license = action.license

      for (let [ id, license ] of Object.entries( state.licenses ) ) {
        license.active = ( action.license.id == id )
      }

      state.licenses[ action.license.id ] = action.license
      state.licenses = Object.assign({},state.licenses)
      state.licensesSorted = sortLicenses ( { licenses : state.licenses } )  

      break;
    case SET_LICENSES:
      state.licenses = action.licenses
      state.licensesSorted = sortLicenses ( { licenses : action.licenses } )
      break;
    case RESET:
      state = initialState()
  }

  return state
}

function sortLicenses( options={} ) {
  var sortable=[]

  for (let [ id, license ] of Object.entries( options.licenses ) ) {
      sortable.push( license )
  }

  if ( sortable.length ) sortable.sort( (a,b) => (( a.name ).toLowerCase() > ( b.name ).toLowerCase() ? 1 : -1 ) )

  return sortable
}
